import { intercept } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Button, Col, FormGroup, Label, Row } from 'reactstrap';
import { UserStore } from 'src/Stores/User/UserStore';
import { IUser } from '../../../Interfaces/UserInterface';
import ButtonRow from '../../ButtonRow';
import { EButton, EInput, EInputMask } from '../../EInput';
import { UserPreferences } from './UserPreferences';


@inject('stores')
@observer
class Profile extends React.Component {
    public props: any;
    private mask = new EInputMask();
    public userDetails: IUser = new IUser();
    public usersDisposer: any;
    public UserStore: UserStore;
    public errorStore: any;
    public MessageStore: any;
    public passwordsDontMatch: boolean = true;

    public state = {
        passwordsDontMatch: this.passwordsDontMatch,
        redirect: false,
        userDetails: this.userDetails,
    };

    constructor(props: any) {
        super(props);

        this.UserStore = this.props.stores.UserStore;
        this.errorStore = this.props.stores.ErrorsStore;
        this.MessageStore = this.props.stores.MessageStore;

    }

    public componentDidMount() {
        this.createDisposers();

        this.UserStore.getProfile();
    }

    public componentWillUnmount() {
        this.clearDisposers();
    }

    private createDisposers() {
        this.usersDisposer = intercept(this.UserStore, 'user', (change: any) => {
            const userDetails: IUser = change.newValue;
            if (userDetails) {
                this.setState({
                    userDetails
                });
            }
            return change;
        });
    }

    private clearDisposers() {
        this.usersDisposer();
    }

    public handleChange = (event: any) => {
        const userDetails = this.state.userDetails;
        
        if (event.target.name === 'phoneNumber' && userDetails.phoneNumber === userDetails.phoneMobile) {
            userDetails.phoneNumber = this.mask.phone(event.target.value);
            userDetails.phoneMobile = userDetails.phoneNumber;
        }

        if(event.target.name.includes('phone')) {
            userDetails[event.target.name] = this.mask.phone(event.target.value);
        } else {
            userDetails[event.target.name] = event.target.value;
        }

        this.setState({
            isDirty: true,
            userDetails
        }, () => {
            this.confirmPasswordMatch();
        });
    }

    public handleSaveUser = () => {
        const user = this.state.userDetails;
        for (const key in user.preferences) {
            if (user.preferences.hasOwnProperty(key) && user.preferences[key] === '')
            {
                delete user.preferences[key];
            }
        }
        this.UserStore.putProfile(user)
            .then(data => {
                if (data) {
                    this.MessageStore.addMessage(
                        'Changes have been saved',
                        'success'
                        );
                }
            });
    }

    public handleChangePreference = (preference: string, value: string) => {
        const userDetails = this.state.userDetails;
        userDetails.preferences[preference] = value;
        this.setState({userDetails});
    }

    public confirmPasswordMatch() {
        const hasError = ( this.state.userDetails.newPassword !== this.state.userDetails.confirmPassword );

        this.setState({
            passwordsDontMatch: !hasError
        });
    }

    public resetUserPassword = () => {
        const areYouSure = 
            confirm(`Generating a new passphrase means that your current passphrase will no longer be valid for login. A new, random passphrase will be sent to your email address for you to use when logging into the app.\n\nAre you sure you want to generate a new passphrase?`);
        
        if (areYouSure) {
            this.UserStore.resetPassphrase();
        }
    }

    public render() {
        return(
                <div>
                    <Row className="header">
                        <Col md="12">
                            <h2 className="float-left">Profile</h2>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="6">
                            <FormGroup className="required">
                                <Label>First Name</Label>
                                <EInput 
                                    type="text" 
                                    name="firstName"
                                    required={true} 
                                    value={this.state.userDetails.firstName} 
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                            <FormGroup className="required">
                                <Label>Last Name</Label>
                                <EInput 
                                    type="text" 
                                    name="lastName"
                                    required={true} 
                                    value={this.state.userDetails.lastName} 
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                            <FormGroup className="required">
                                <Label>Email / Username</Label>
                                <EInput 
                                    type="text" 
                                    name="email" 
                                    required={true}
                                    value={this.state.userDetails.email} 
                                    data-validation="email" 
                                    disabled={true}
                                />
                            </FormGroup>
                            <Row>
                                {/* <Col md="6" className={(!this.state.passwordsDontMatch) ? 'passwords-not-matched' : 'passwords-matched'}>
                                    <h5>Change Password</h5>
                                    <FormGroup>
                                        <Label>New Password</Label>
                                        <Input 
                                            type="password" 
                                            name="newPassword"
                                            value={this.state.userDetails.newPassword} 
                                            onChange={this.handleChange}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>Confirm Password</Label>
                                        <Input 
                                            type="password" 
                                            name="confirmPassword"
                                            value={this.state.userDetails.confirmPassword} 
                                            onChange={this.handleChange}
                                        />
                                    </FormGroup>
                                    <p className="matched-message">Passwords do not match. Please try again.</p>
                                </Col> */}
                                <Col>
                                    <Button color="primary" onClick={this.resetUserPassword}>Generate New Passphrase</Button>
                                </Col>
                            </Row>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label>Location</Label>
                                <EInput 
                                    type="text" 
                                    name="location"
                                    value={this.state.userDetails.location} 
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                            <FormGroup className="required">
                                <Label>Notifications Mobile Phone</Label>
                                <EInput 
                                    type="text" 
                                    name="phoneNumber"
                                    required={true} 
                                    value={this.state.userDetails.phoneNumber} 
                                    data-mask="phone" 
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>Mobile Phone</Label>
                                <EInput 
                                    type="text" 
                                    name="phoneMobile"
                                    value={this.state.userDetails.phoneMobile} 
                                    data-mask="phone" 
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>Alternate Phone</Label>
                                <EInput 
                                    type="text" 
                                    name="phoneAlternate"
                                    value={this.state.userDetails.phoneAlternate} 
                                    data-mask="phone" 
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <UserPreferences key={JSON.stringify(this.state.userDetails.preferences)} handlePreferenceChange={this.handleChangePreference} preferences={this.state.userDetails.preferences} />
                    <ButtonRow>
                        <EButton color="primary" onClick={this.handleSaveUser}>Save User</EButton>
                    </ButtonRow>
                </div>
        );
    }

}

export default Profile;


// WEBPACK FOOTER //
// ./src/Components/Main/Profile/Profile.tsx